import { useEffect, useState } from 'react';
import { getShapePositionByScreenBound } from '@meitu/whee-infinite-canvas';
import useAIToolsCanvasStore from '@/store/useAIToolsCanvasStore';

/**
 * 获取画布上主图在屏幕上的边界（用于笔刷光标仅在图片区域内显示）
 */
export default function useImageBounds() {
  const render = useAIToolsCanvasStore((state) => state.render);
  const imageTarget = useAIToolsCanvasStore((state) => state.imageTarget);

  const [bounds, setBounds] = useState({
    left: 0, right: 0, top: 0, bottom: 0,
  });

  useEffect(() => {
    if (!render || !imageTarget) {
      setBounds({
        left: 0, right: 0, top: 0, bottom: 0,
      });
      return undefined;
    }

    const update = () => {
      const data = getShapePositionByScreenBound.call(render, imageTarget);
      if (data) {
        setBounds({
          left: data.left,
          right: data.right,
          top: data.top,
          bottom: data.bottom,
        });
      }
    };

    update();
    render._FC.on('viewport:zoom', update);

    return () => {
      render._FC.off('viewport:zoom', update);
    };
  }, [render, imageTarget]);

  return bounds;
}
